import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const notificationSettingsPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.notificationSettings(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/notifications/settings"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
